import React from 'react'

import {
  Heading
} from '../'

import {
  showAsCurrency
} from '../../utils'

export default class KeyValueTable extends React.Component {
  getRows = (data, keyColumnSize) => {
    let keyCounter = 0
    let keys = data ? Object.keys(data) : []
    let rows = []

    keys.forEach((keyValue) => {
      let value = data[keyValue]
      if (this.props.containsKeyValueTableObjects) {
        if (value && typeof value === 'object') {
          if (this.props.highlight) {
            value = value[this.props.highlight]
          } else {
            value = <div>
              <table className='slds-table slds-table_bordered slds-table_cell-buffer slds-table_fixed-layout'>
                <tbody>
                  {this.getRows(value, '1-of-2')}
                </tbody>
              </table>
            </div>
          }
        }
      }
      if (this.props.actionRows) {
        if (this.props.actionRows[keyValue] !== null) {
          rows.push(
            <KeyValueTableWithActionsRow
              header={keyValue}
              value={value}
              key={'kv_row_'+keyCounter++}
              rowActions={this.props.actionRows[keyValue]}
              keyFieldNoWrap={this.props.keyFieldNoWrap}
              keyColumnSize={this.props.loanApplicationStatusRow
                ? '10-of-12'
                : keyColumnSize
                  ? keyColumnSize
                  : '1-of-4'
                }
            />
          )
        } else {
          rows.push(
            <KeyValueTableRow
              header={keyValue}
              value={value}
              key={'kv_row_'+keyCounter++}
              keyFieldNoWrap={this.props.keyFieldNoWrap}
              keyColumnSize={this.props.loanApplicationStatusRow
                ? '10-of-12'
                : keyColumnSize
                  ? keyColumnSize
                  : '1-of-4'
                }
            />
          )
        }
      } else {
        rows.push(
          <KeyValueTableRow
            header={keyValue}
            value={this.displayAsCurrency(value)}
            key={'kv_row_'+keyCounter++}
            highlight={this.props.highlight === keyValue}
            keyFieldNoWrap={this.props.keyFieldNoWrap}
            keyColumnSize={this.props.loanApplicationStatusRow
              ? '10-of-12'
              : keyColumnSize
                ? keyColumnSize
                : '1-of-4'
              }
          />
        )
      }
    })

    return rows
  }

  displayAsCurrency = (value) => (
    this.props.currencyValues && typeof value === 'string'
      ? showAsCurrency('R', value)
      : value
  )

  render() {
    let rows = this.getRows(this.props.data, this.props.keyColumnSize)

    return (
      <div className={this.props.className}>
        {this.props.heading &&
          <Heading marginBottom={5}>
            {this.props.heading}
          </Heading>
        }
        <table className={`slds-table slds-table_bordered slds-table_cell-buffer slds-table_fixed-layout ${this.props.tableClassName}`}>
          <tbody>
            {rows}
          </tbody>
        </table>
      </div>
    )
  }
}

export class KeyValueTableRow extends React.Component {
  render() {
    return (
      <tr>
        <th
          className={`${this.props.highlight ? 'slds-border_left slds-border_top slds-border_bottom ': ' '}slds-size_${this.props.keyColumnSize} slds-theme_shade slds-text-heading_label ${this.props.keyFieldNoWrap ? 'slds-truncate' : 'slds-cell-wrap'}`}
          title={this.props.header}>
          {this.props.highlight
            ? <b>{this.props.header}</b>
            : this.props.header
          }
        </th>
        <td className={`${this.props.highlight ? 'slds-border_top slds-border_right slds-border_bottom ': ' '}slds-cell-wrap`}>
          {this.props.highlight
            ? <b>{this.props.value}</b>
            : this.props.value
          }
        </td>
      </tr>
    )
  }
}

export class KeyValueTableWithActionsRow extends React.Component {
  render() {
    if (this.props.rowActions) {
      return (
        <tr>
          <th
            className={`slds-size_${this.props.keyColumnSize} slds-theme_shade slds-text-heading_label ${this.props.keyFieldNoWrap ? 'slds-truncate' : 'slds-cell-wrap'}`}
            title={this.props.header}>
            {this.props.header}
          </th>
          <td className='slds-cell-wrap'>
            {this.props.value}
          </td>
          <td className='slds-cell-wrap'>
            {this.props.rowActions}
          </td>
        </tr>
      )
    } else {
      return (
        <tr>
          <th
            className={`slds-size_1-of-4 slds-theme_shade slds-text-heading_label ${this.props.keyFieldNoWrap ? 'slds-truncate' : 'slds-cell-wrap'}`}
            title={this.props.header}>
            {this.props.header}
          </th>
          <td className='slds-cell-wrap'>
            {this.props.value}
          </td>
        </tr>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/key-value-table/index.js